import { z } from 'zod';

export const AuditAuthMethodSchema = z.enum(['session', 'api_token']);
export type AuditAuthMethod = z.infer<typeof AuditAuthMethodSchema>;

export const AuditEventSchema = z.object({
  id: z.string(),
  orgId: z.string().nullable(),
  userId: z.string().nullable(),
  userName: z.string().nullable().optional(),
  entityType: z.string(),
  entityId: z.string().nullable(),
  action: z.string(),
  previousValue: z.string().nullable(),
  newValue: z.string().nullable(),
  ip: z.string().nullable(),
  userAgent: z.string().nullable(),
  /** The real actor when the action was taken under impersonation (platform admin). */
  impersonatorId: z.string().nullable().optional(),
  impersonatorName: z.string().nullable().optional(),
  /** How the actor authenticated; null = unauthenticated path or pre-dates recording. */
  authMethod: AuditAuthMethodSchema.nullable(),
  apiTokenId: z.string().nullable(),
  /** Joined token name; null if the token row is gone. */
  apiTokenName: z.string().nullable().optional(),
  createdAt: z.string(),
});
export type AuditEvent = z.infer<typeof AuditEventSchema>;

export const AuditQuerySchema = z.object({
  entityType: z.string().optional(),
  entityId: z.string().optional(),
  action: z.string().optional(),
  userId: z.string().optional(),
  /** Cross-tenant filter (platform audit only). */
  orgId: z.string().optional(),
  authMethod: AuditAuthMethodSchema.optional(),
  apiTokenId: z.string().optional(),
  from: z.string().optional(),
  to: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(200).default(50),
  offset: z.coerce.number().int().min(0).default(0),
});
export type AuditQuery = z.infer<typeof AuditQuerySchema>;
